import React from "react";
import { Waves, Ticket, Check, Phone, Ship } from "lucide-react";
import { useCruise } from "../context/CruiseContext";
import { Button } from "./ui/button";

const Suncebeat = () => {
  const { suncebeat, EVENT } = useCruise();
  if (!suncebeat) return null;

  return (
    <section id="suncebeat" data-testid="suncebeat-section" className="relative bg-black py-20 sm:py-28 overflow-hidden">
      {/* backdrop image */}
      <div className="absolute inset-0">
        <img src={suncebeat.image} alt="SuncéBeat Lisbon" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/40" />
      </div>

      <div className="relative max-w-6xl mx-auto px-5">
        <div className="flex items-center gap-2 text-[var(--hh-gold)] mb-3">
          <Waves size={18} />
          <p className="font-cond uppercase tracking-[0.4em] text-sm">{suncebeat.kicker}</p>
        </div>
        <h2 className="font-cond font-bold uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-none">
          {suncebeat.title}
        </h2>
        <p className="mt-3 font-cond uppercase tracking-widest text-[var(--hh-gold)] text-base sm:text-lg">
          {suncebeat.dates}
        </p>
        <p className="mt-5 text-white/75 max-w-2xl text-base leading-relaxed">{suncebeat.description}</p>

        <div className="mt-10 grid md:grid-cols-2 gap-6">
          {/* What's included */}
          <div className="bg-white/5 border border-white/10 rounded-2xl backdrop-blur-sm p-6">
            <div className="flex items-center gap-2 mb-4">
              <Ship size={18} className="text-[var(--hh-gold)]" />
              <h3 className="font-cond font-bold uppercase tracking-widest text-white text-lg">Your Cruise Includes</h3>
            </div>
            <ul className="space-y-3">
              {suncebeat.included.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-white/80">
                  <Check size={18} className="text-[var(--hh-gold)] shrink-0 mt-0.5" />
                  <span className="text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Tickets */}
          <div className="bg-[#E50914]/10 border border-[#E50914]/30 rounded-2xl backdrop-blur-sm p-6">
            <div className="flex items-center gap-2 mb-4">
              <Ticket size={18} className="text-[#E50914]" />
              <h3 className="font-cond font-bold uppercase tracking-widest text-white text-lg">SuncéBeat Ticket Info</h3>
            </div>
            <ul className="space-y-3">
              {suncebeat.tickets.map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-white/80">
                  <span className="text-[#E50914] font-bold shrink-0">+</span>
                  <span className="text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="mt-6 text-white/45 text-xs max-w-2xl">{suncebeat.note}</p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3">
          <a href={EVENT.phoneHref} data-testid="suncebeat-cta-call">
            <Button className="bg-[var(--hh-gold)] hover:opacity-90 text-[#0A0A0A] font-cond uppercase tracking-widest rounded-full px-7 h-12 w-full sm:w-auto">
              <Phone size={16} className="mr-2" /> Ask About SuncéBeat Tickets
            </Button>
          </a>
          <a href={EVENT.bookingUrl} target="_blank" rel="noopener noreferrer" data-testid="suncebeat-cta-book">
            <Button variant="outline" className="border-white/25 bg-transparent text-white hover:bg-white hover:text-black font-cond uppercase tracking-widest rounded-full px-7 h-12 w-full sm:w-auto">
              Book Your Cabin
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Suncebeat;
